import { TFunction } from "i18next";
import * as yup from "yup";

type SchemaTranslateKey =
  | "contact.form.first_name"
  | "contact.form.last_name"
  | "billing_address.form.street_address_line1"
  | "billing_address.form.street_address_line2"
  | "billing_address.form.country"
  | "billing_address.form.zip_or_postal_code"
  | "billing_address.form.city"
  | "billing_address.form.state_or_province";

const tSchema = (t: TFunction, key: SchemaTranslateKey) =>
  t(`training.actions.purchase_test.dialog.core.steps.${key}`);

export const contactSchema = (t: TFunction) =>
  yup
    .object({
      firstName: yup
        .string()
        .label(tSchema(t, "contact.form.first_name"))
        .required(),
      lastName: yup
        .string()
        .label(tSchema(t, "contact.form.last_name"))
        .required(),
    })
    .required();

export const billingAddressSchema = (t: TFunction) =>
  yup
    .object({
      streetAddressLine1: yup
        .string()
        .label(tSchema(t, "billing_address.form.street_address_line1"))
        .required(),
      streetAddressLine2: yup
        .string()
        .label(tSchema(t, "billing_address.form.street_address_line2")),
      country: yup
        .string()
        .label(tSchema(t, "billing_address.form.country"))
        .required(),
      zipcodeOrPostalCode: yup
        .string()
        .label(tSchema(t, "billing_address.form.zip_or_postal_code"))
        .required(),
      city: yup
        .string()
        .label(tSchema(t, "billing_address.form.city"))
        .required(),
      stateOrProvince: yup
        .string()
        .label(tSchema(t, "billing_address.form.state_or_province"))
        .required(),
      countryHasState: yup.boolean().nullable(),
    })
    .required();

export const billingAddressIdSchema = yup
  .object({
    billingAddressId: yup.string().required(),
  })
  .required();

export const creditCardTokenSchema = () =>
  yup
    .object({
      stripeToken: yup.string().required(),
      last4: yup.string().required(),
      billingName: yup.string().required(),
    })
    .required();

export const purchaseTestSchema = (t: TFunction) =>
  yup
    .object({
      contact: contactSchema(t),
      creditCard: creditCardTokenSchema(),
      billingAddress: billingAddressSchema(t),
      billingAddressId: yup.string().required(),
      rateId: yup.number().required(),
      totalCost: yup.number().required(),
      stripeToken: yup.string().required(),
    })
    .required();

export type PurchaseTestForm = yup.InferType<
  ReturnType<typeof purchaseTestSchema>
>;
